/*
Dependencies :
npm install react react-dom
npm install --save redux
npm install --save react-redux
npm install axios
npm i --save @fortawesome/fontawesome-svg-core
npm i --save @fortawesome/free-solid-svg-icons
npm i --save @fortawesome/react-fontawesome
npm install --save react-router-dom
npm install --save redux-thunk
npm install js-file-download --save

*/


import React from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import apiReducer from './Store/Reducers/apiReducer';
import appReducer from './Store/Reducers/appReducer';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { combineReducers } from 'redux'
import thunk from 'redux-thunk';
import App from './Application/Components/App';


const combinedReducer = combineReducers({apiReducer,appReducer}); //  combineReducers({apiReducer, messagingReducer}); for EXAMPLE
const store = createStore(combinedReducer, applyMiddleware(thunk));
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>
  , document.getElementById('root'));

serviceWorker.unregister();